import { createApi } from '@reduxjs/toolkit/query/react';
import Organization from 'models/Organization';
import { axiosBaseQuery } from 'services/api';

export const organizationsApi = createApi({
  reducerPath: 'organizationsApi',
  baseQuery: axiosBaseQuery({
    apiPath: '/api/organizations/',
  }),
  endpoints: builder => ({
    // List ALL organizations
    listOrganizations: builder.query({
      query: query => ({ params: { ...query, limit: 100 } }),
      transformResponse: response => {
        const data = response.results || response;
        if (!Array.isArray(data)) return [];
        return data.map(org => new Organization(org));
      },
    }),
    // Fetch an organization
    getOrganizationById: builder.query({
      query: organizationId => ({ url: `${organizationId}/` }),
      transformResponse: data => new Organization(data),
    }),
  }),
});

export const { useListOrganizationsQuery, useGetOrganizationByIdQuery } = organizationsApi;
